import base from './base'; // 导入接口域名列表
import axios from '@/utils/http';
import fetch from "../utils/fetch"; // 导入http中创建的axios实例


const area = {
    // 获取区域ID
    getAreaIdByDoorId(doorId) {
        return axios.get(`${base.url}${base.path}/area/byDoor?doorId=` + doorId);
    },
    // 获取区域基础配置
    getBasicConfig(id) {
        return axios.get(`${base.url}${base.path}/area/config/` + id);
    },
   
    getParkingPaymentInfo(data) {
        return axios.post(`${base.url}${base.path}/keyTop/getParkingPaymentInfo`,data);
    }
}

export default area;
